export const truncateName = (name: string, max = 64) => {
  if (!name) {
    return '';
  }
  if (name.length <= max) {
    return name;
  }
  const head = 55;
  const tail = 6;
  return `${name.slice(0, head)}...${name.slice(-tail)}`;
};
